<template>
  <div class="noticesXh">
    <div style="margin-bottom: 10px;">
      <el-text style="font-size: larger; font-weight: bolder;">校徽</el-text>
    </div>
    <el-form :inline="true">
      <el-form-item :label="util.language('校名')">
        <el-input style="width: 200px;" placeholder="请输入完整校名" v-model="searchParam.kkey" clearable />
      </el-form-item>
      <el-form-item>
        <el-button-group>
          <el-button type="primary" @click="commitFindList()" :loading="loading.find">查询</el-button>
        </el-button-group>
      </el-form-item>
      <el-form-item>
        <el-button-group>
          <el-button type="primary" @click="add()">上传校徽</el-button>
          <el-button type="danger" :disabled="show.selected.length < 1" @click="del()">删除</el-button>
        </el-button-group>
      </el-form-item>
    </el-form>
    <el-table :data="data.noticeList" @selection-change="selectionChange()" ref="tabRef" border style="height: calc(100vh - 220px);" v-loading="loading.find">
      <el-table-column type="selection" width="55" align="center" />
      <el-table-column label="校徽" width="150">
        <template #default="scope">
          <div style="width: 70px; height: 70px; background-color: antiquewhite;">
            <el-image style="width: 100%; height: 100%;" :src="scope.row.file" fit="cover" />
          </div>
        </template>
      </el-table-column>
      <el-table-column label="校名" align="center">
        <template #default="scope">
          <el-text>{{ scope.row.kkey }}</el-text>
        </template>
      </el-table-column>
    </el-table>
    <div style="height: 10px;" />
    <el-pagination v-model:current-page="searchParam.pageNum" v-model:page-size="searchParam.pageSize" :page-sizes="[50, 100, 200]" background layout="total, sizes, prev, pager, next, jumper" :total="data.noticeTotal" @change="commitFindList()" />
  </div>

  <el-dialog v-model="show.addXh" title="上传校徽（同名校徽将被替换）" width="30%">
    <el-form :model="data" label-width="auto">
      <el-form-item label="">
        <el-upload style="width: 100%;" :action="api.baseURL() + '/backend/notice/uploadXh'" :headers="api.tokenHeader()" multiple drag :on-remove="() => ElMessage.warning('请在校徽列表中删除校徽！此处只删除了上传记录。')"
          :on-success="() => ElMessage.success('保存成功')" :on-error="() => ElMessage.error('上传失败')" :on-preview="(f) => util.previewElfile(f)" accept=".png,.jpg,.jpeg">
          <el-text>将文件名设置为学校名称，点击或拖转到此处上传校徽图片（png\jpg\jpeg）</el-text>
        </el-upload>
      </el-form-item>
    </el-form>
    <template #footer>
      <span class="dialog-footer">
        <el-button @click="commitFindList()">完成</el-button>
      </span>
    </template>
  </el-dialog>
</template>

<script setup>
import { reactive, ref } from 'vue'
import { useRouter } from 'vue-router'
import { ElMessage, ElMessageBox } from 'element-plus'
import api from '../../apis/api'
import apiNative from '../../apis/apiNative'
import cache from '../../utils/cache'
import util from '../../utils/util'
import math from '../../utils/math'

const router = useRouter()
const tabRef = ref()

const loading = reactive({
  find: false,
})
const data = reactive({
  noticeList: [],
  noticeTotal: 0,
})

const show = reactive({
  selected: [],
  addXh: false,
})

const searchParam = reactive({})
const resetSearchParam = () => {
  searchParam.kkey = null
  searchParam.type = 'REPORT_XH'
  searchParam.pageNum = 1
  searchParam.pageSize = 50
}
resetSearchParam()

const commitFindList = () => {
  console.log(searchParam)
  show.addXh = false
  api.get('/backend/notice/getNoticePage', { params: searchParam }).then(res => {
    data.noticeList = res.list
    data.noticeTotal = res.total
  }).finally(() => {
    loading.find = false
  })
}
commitFindList()

const selectionChange = () => {
  show.selected = tabRef.value.getSelectionRows()
}

const add = () => {
  show.addXh = true
}

const del = () => {
  const notices = tabRef.value.getSelectionRows()
  const noticeIdList = notices.map(notice => notice.id)
  ElMessageBox.confirm('', {
    title: '确认删除',
    message: '将要删除选中的项？',
    autofocus: false,
    confirmButtonText: '删除',
    cancelButtonText: '取消',
  }).then(() => {
    api.post('/backend/notice/delNotice', { ids: noticeIdList }).then(() => {
      ElMessage.success('删除成功')
      commitFindList()
    })
  })
}
</script>

<style lang="less">
.noticesXh{
  margin: auto;
  max-width: 900px;
}
</style>